module.exports = __webpack_public_path__ + "static/img/daily.e17b168.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buy_more/daily.png
// module id = H5P7
// module chunks = 1